/** Hängt den aktuellen Query-String (z. B. ?lang=DE bei Multi-Lingual-
 *  Projekten) an ein Navigationsziel an. Standard-Projekte haben einen
 *  leeren search → identisches Verhalten wie vorher. */
export function withSearch(path: string, search: string): string {
  return search ? `${path}${search}` : path;
}
